import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-updation-applicant-form',
  templateUrl: './updation-applicant-form.component.html',
  styleUrls: ['./updation-applicant-form.component.css']
})
export class UpdationApplicantFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/applicant/updation-applicant-details/updation-applicant-form/updation-applicant-form.component.ts